import { render, staticRenderFns } from "./secure-page.vue?vue&type=template&id=2216a2ba&scoped=true&"
import script from "./secure-page.vue?vue&type=script&lang=js&"
export * from "./secure-page.vue?vue&type=script&lang=js&"
import style0 from "./secure-page.vue?vue&type=style&index=0&id=2216a2ba&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2216a2ba",
  null
  
)

export default component.exports